
import { instantiate } from './ArcaneDesignSystem-catalog-composeApp.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
memory,
_initialize
} = exports


